// Mock data for Yuville-inspired site

export const NAV_LINKS = [
  { id: 'accueil', label: 'Accueil', href: '#accueil' },
  { id: 'apropos', label: 'À propos', href: '#apropos' },
  { id: 'trading', label: 'Trading', href: '#trading' },
  { id: 'plateforme', label: 'Plateforme', href: '#plateforme' },
  { id: 'partenariat', label: 'Partenariat', href: '#partenariat' },
  { id: 'equipe', label: 'Équipe', href: '#equipe' },
  { id: 'contact', label: 'Contact', href: '#contact' },
];

export const TRADING_COMMODITIES = [
  {
    id: 'cuivre',
    name: 'Cuivre',
    description: 'Cathodes, concentrés et minerais de cuivre pour l\'industrie mondiale.',
    demand: 'Forte demande',
    unit: 'USD / tonne',
    price: '9 480',
    trend: '+2.3%',
  },
  {
    id: 'aluminium',
    name: 'Aluminium',
    description: 'Lingots et alliages d\'aluminium destinés aux manufacturiers.',
    demand: 'Demande stable',
    unit: 'USD / tonne',
    price: '2 350',
    trend: '+0.8%',
  },
  {
    id: 'soufre',
    name: 'Soufre',
    description: 'Soufre granulé et formé pour applications industrielles et agricoles.',
    demand: 'Demande croissante',
    unit: 'USD / tonne',
    price: '215',
    trend: '+3.1%',
  },
  {
    id: 'potasse',
    name: 'Potasse',
    description: 'Chlorure de potassium pour engrais et industries chimiques.',
    demand: 'Forte demande',
    unit: 'USD / tonne',
    price: '345',
    trend: '-0.6%',
  },
  {
    id: 'bitume',
    name: 'Bitume',
    description: 'Bitume de qualité routière et industrielle.',
    demand: 'Demande stable',
    unit: 'USD / tonne',
    price: '520',
    trend: '+1.2%',
  },
  {
    id: 'or',
    name: 'Or',
    description: 'Lingots d\'or certifiés pour investisseurs et clients institutionnels.',
    demand: 'Forte demande',
    unit: 'USD / once',
    price: '2 410',
    trend: '+1.8%',
  },
];

export const INDUSTRIAL_SERVICES = [
  {
    id: 'missions',
    number: '01',
    title: 'Missions Commerciales',
    description: 'Organisation complète de missions commerciales en Chine : rencontres B2B, visites d\'usines, négociations et suivi post-mission.',
    highlights: ['Agenda personnalisé', 'Interprète bilingue', 'Visites d\'usines', 'Suivi post-mission'],
  },
  {
    id: 'partenaires',
    number: '02',
    title: 'Recherche de Partenaires',
    description: 'Identification et validation de partenaires industriels ou de manufacturiers chinois qualifiés selon vos critères précis.',
    highlights: ['Vérification légale', 'Audit qualité', 'Négociation contrats', 'Accompagnement long terme'],
  },
  {
    id: 'rescapes',
    number: '03',
    title: 'Produits Rescapés',
    description: 'Biens de consommation retenus en douane, invendus ou non payés, disponibles à prix avantageux pour distributeurs et consommateurs.',
    highlights: ['Prix négociés', 'Lots disponibles', 'Livraison rapide', 'Traçabilité complète'],
  },
  {
    id: 'marchandises',
    number: '04',
    title: 'Diverses Marchandises',
    description: 'Plus de 16 catégories de marchandises disponibles pour distributeurs, détaillants et grossistes à travers le Canada.',
    highlights: ['16 catégories', 'Import direct', 'Volumes flexibles', 'Support logistique'],
  },
  {
    id: 'entreprises',
    number: '05',
    title: 'Entreprises du Mois',
    description: 'Chaque mois, présentation de deux entreprises chinoises sélectionnées et de leurs gammes de produits phares.',
    highlights: ['Sélection mensuelle', 'Fiches détaillées', 'Contact direct', 'Échantillons possibles'],
  },
];

export const PRODUCT_CATEGORIES = [
  'Électronique',
  'Textiles & Vêtements',
  'Électroménager',
  'Outillage industriel',
  'Équipements de sécurité',
  'Mobilier & Décoration',
  'Jouets & Loisirs',
  'Cosmétiques',
  'Articles ménagers',
  'Pièces automobiles',
  'Équipement médical',
  'Fournitures de bureau',
  'Éclairage & LED',
  'Sports & Plein air',
  'Emballage industriel',
  'Machinerie légère',
];

export const RESCUED_PRODUCTS = [
  {
    id: 'r1',
    name: 'Lot Électroménager Premium',
    origin: 'Retenu en douane – Montréal',
    quantity: '480 unités',
    discount: '-45%',
    category: 'Électroménager',
  },
  {
    id: 'r2',
    name: 'Vêtements Techniques Hiver',
    origin: 'Non payé par client – Vancouver',
    quantity: '2 300 pièces',
    discount: '-60%',
    category: 'Textiles',
  },
  {
    id: 'r3',
    name: 'Outillage Professionnel',
    origin: 'Faillite distributeur – Toronto',
    quantity: '1 200 kits',
    discount: '-38%',
    category: 'Outillage',
  },
  {
    id: 'r4',
    name: 'Éclairage LED Commercial',
    origin: 'Retenu en douane – Halifax',
    quantity: '5 600 unités',
    discount: '-52%',
    category: 'Éclairage',
  },
];

export const COMPANIES_OF_MONTH = [
  {
    id: 'c1',
    name: 'Shenzhen HuaTech Industries',
    city: 'Shenzhen, Guangdong',
    founded: '2008',
    employees: '1 200+',
    specialty: 'Composants électroniques et modules IoT',
    products: ['Modules Wi-Fi', 'Capteurs industriels', 'Cartes de développement', 'Passerelles IoT'],
    certifications: ['ISO 9001', 'CE', 'FCC', 'RoHS'],
  },
  {
    id: 'c2',
    name: 'Ningbo Precision Manufacturing',
    city: 'Ningbo, Zhejiang',
    founded: '2003',
    employees: '850',
    specialty: 'Pièces mécaniques de précision et outillage',
    products: ['Pièces usinées CNC', 'Moules industriels', 'Composants automobiles', 'Outillage sur mesure'],
    certifications: ['ISO 9001', 'IATF 16949', 'ISO 14001'],
  },
];

export const WHY_US = [
  {
    id: 'w1',
    title: 'Excellence Transparente',
    description: 'Une approche directe, honnête et transparente dans toutes nos transactions commerciales.',
  },
  {
    id: 'w2',
    title: 'Sourcing Efficace',
    description: 'Expertise dans le sourcing rapide de matières premières difficiles à trouver pour nos clients.',
  },
  {
    id: 'w3',
    title: 'Partenaire Fiable',
    description: 'Un accompagnement personnalisé et une relation de confiance sur le long terme.',
  },
  {
    id: 'w4',
    title: 'Réseau Chinois Exclusif',
    description: 'Accès privilégié à des milliers de manufacturiers chinois leaders dans leur industrie.',
  },
];

export const TEAM = [
  {
    id: 't1',
    name: 'Denis Villeneuve',
    role: 'Président et Fondateur',
    bio: 'Longue expérience en financement d\'entreprises, production pour le cinéma et la télévision, en commerce international et négociations de matières premières et d\'instruments médicaux.',
    image: '/assets/denis-villeneuve.jpg',
  },
  {
    id: 't2',
    name: 'Jimmy Changtao Yu',
    role: 'Vice-Président et Fondateur',
    bio: 'Co-fondateur de Yuville, il dirige la stratégie de développement et les relations avec le marché chinois.',
    image: '/assets/jimmy-yu.jpg',
  },
  {
    id: 't3',
    name: 'Yan Yu',
    role: 'Directeur Plateforme Chinoise',
    bio: 'Gestionnaire de la plateforme reliant les manufacturiers chinois aux entreprises canadiennes. Vaste expérience en ventes, marketing et entrepreneuriat.',
    image: '/assets/yan-yu.png',
  },
];

export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1724597500306-a4cbb7d1324e?w=1920&q=80',
  trading: 'https://images.unsplash.com/photo-1613031595478-de64daa4b8f9?w=1200&q=80',
  containers: 'https://images.unsplash.com/photo-1605732562742-3023a888e56e?w=1200&q=80',
  port: 'https://images.unsplash.com/photo-1670121180530-cfcba4438038?w=1200&q=80',
  factory: 'https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?w=1200&q=80',
  robotics: 'https://images.unsplash.com/photo-1647427060118-4911c9821b82?w=1200&q=80',
  meeting: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=1200&q=80',
  team: 'https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?w=1200&q=80',
  warehouse: 'https://images.unsplash.com/photo-1553413077-190dd305871c?w=1200&q=80',
};
